import { createAction, props } from '@ngrx/store';
import { IUser, UserPermission } from '../../models/user.model';
import { AuthState } from './auth.state';

export enum AuthActionTypes {
    LOGIN_SUCCESS = '[AUTH] Login Success',
    LOGIN_ERROR = '[AUTH] Login Error',
    SET_USER = '[AUTH] Set user',
    SET_AUTH_STATE = '[AUTH] Set auth state',
    CLEAN_AUTH_STATE = '[AUTH] Clean auth state',
    SET_PERMISSIONS = '[AUTH] set permissions',
    LOCK_EDITING = '[AUTH] set LOCK_EDITING',
    UNLOCK_EDITING = '[AUTH] set UNLOCK_EDITING',

}

export const loginSucces = createAction(
    AuthActionTypes.LOGIN_SUCCESS,
)

export const loginError = createAction(
    AuthActionTypes.LOGIN_SUCCESS,
)

export const setUser = createAction(
    AuthActionTypes.SET_USER,
    props<{ user: IUser }>()
)

export const setPermissions = createAction(
  AuthActionTypes.SET_PERMISSIONS,
  props<{ permissions: UserPermission }>()
)

export const cleantAuthState = createAction(
    AuthActionTypes.CLEAN_AUTH_STATE
)
